import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';
import React from 'react';
import { useInView } from 'react-intersection-observer';

import { propTypesDataHorizontalCardCta } from './HorizontalCardCta.proptypes.js';

import { CardCTA } from './CardCTA';

import * as S from './HorizontalCardCta.styles.js';

export const HorizontalCardCtaSlice = ({ slice }) => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  if (!slice) {
    return null;
  }

  const data = slice.primary || {};
  const { horizontal_card_slice_id: id, horizontal_card_title: title } =
    data || '';

  if (!title) {
    Sentry.captureMessage(
      'Error: missing required data in HorizontalCardCta slice'
    );
    return null;
  }

  const items = slice.items || {};

  return (
    <S.Wrapper id={id} isVisible={true} ref={ref}>
      <S.Title>{title}</S.Title>
      <S.CardWrapper>
        {items.map((item, index) => {
          return <CardCTA index={index} item={item} key={`${item}-${index}`} />;
        })}
      </S.CardWrapper>
    </S.Wrapper>
  );
};

HorizontalCardCtaSlice.propTypes = {
  /**
   * Content of the HeaderBasic slice.
   */
  slice: PropTypes.shape(propTypesDataHorizontalCardCta),
};
